<template>
  <div class="content-box">
    <ModelInfoTwo :detail="detail" />
    <section>
      <Title :title="detail.name + '的写真作品'" />
      <template v-if="detail.album">
        <h4>{{ detail.album.title }}</h4>
        <p class="model-detail-time">{{ detail.time }}</p>
        <article class="list-box">
          <img class="model-album-img"
               v-for="(photo, i) in detail.album.photos"
               v-if="i < 3"
               :src="photo.url"
               :key="i"
               width="49%" />
          <More :bg="detail.album.photos[0].url" />
        </article>
        <p>{{ detail.album.introduction }}</p>
        <article class="tag-list model-tag-list">
          <Tag v-for="(item, index) in detail.album.labels" :origin="'meinvtupian'" :label="item" :key="index"/>
        </article>
      </template>
      <p v-else>
        暂无作品
      </p>
    </section>
    <section>
      <Title :title="'热门美女标签'" />
      <article class="tag-list">
        <Tag v-for="(item, index) in modelDetail.labels" :origin="'meinv'" :label="item" :key="index"/>
      </article>
    </section>
  </div>
</template>

<script>
  import Title from '@/components/TitleM'
  import Tag from '@/components/Tag'
  import More from '@/components/More'
  import ModelInfoTwo from '@/components/ModelInfoTwo'
  import { mapGetters } from 'vuex'
  const moment = require('moment');

  export default {
    components: { Title, Tag, More, ModelInfoTwo },

    // 服务器端渲染，预加载专辑详情数据
    asyncData ({ store, route }) {
      return store.dispatch('getModelDetail', route.params.name)
    },
    computed: {
      ...mapGetters({
        modelDetail: 'modelDetail'  // 处理商品详情数据
      }),
      detail () {
        const basic = this.modelDetail.info.basic;
        const data = {
          cover: basic.headPortraitHttps,
          name: basic.nickName,
          base: `${ basic.height } cm ${ basic.bust } | ${ basic.waist } | ${ basic.hip }`
        };
        const modelAlbum = this.modelDetail.albumList[0];

        if (modelAlbum) {
          data.album = modelAlbum.album
          data.time = moment(modelAlbum.album.realsedAt * 1000).format('YYYY-MM-DD HH:mm:ss');
        }
        return data
      }
    },
  }
</script>
<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .model-detail-time {
    margin-bottom: 10px;
  }
  .more-box {
    width: 49%;
  }
  .model-album-img {
    margin-bottom: 10px;
  }
  .model-tag-list {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/ModelDetail.vue